import EntityWithIdStore from "./EntityWithIdStore";
import StringIndex from "../util/StringIndex";
import _ from "underscore";

export default class EntityWithNameStore extends EntityWithIdStore {
    constructor()
    {
        super();
        this._stringIndex = new StringIndex();
    }

    searchByName(name, sorted)
    {
        const resultObject = this._stringIndex.search(this._stringIndex.getTokenizer().getTokens(name.toLowerCase()));
        const resultArray = _.keys(resultObject);
        return sorted ? _.sortBy(resultArray, id => this._orderIndex[id]) : resultArray;
    }

    getEntityName(entity)
    {
        return entity.name
    }

    _onAdd(newEntity, oldEntity, first)
    {
        if (oldEntity)
            this._removeFromStringIndex(oldEntity);
        this._stringIndex.add(this.getEntityName(newEntity), this.getEntityId(newEntity));
    }

    _onRemove(entity)
    {
        this._removeFromStringIndex(entity);
    }

    _removeFromStringIndex(entity)
    {
        this._stringIndex.remove(this.getEntityName(entity), this.getEntityId(entity));
    }
}


// WEBPACK FOOTER //
// ./web/js/store/EntityWithNameStore.js